import apiClient from './api'

export const GetCertificateService = (publicKey: string) => apiClient.get(
    `/microservice/pki/certificate/v2?public=${publicKey}`
)